import { render, staticRenderFns } from "./saas_list.vue?vue&type=template&id=99df036e&scoped=true&"
import script from "./saas_list.vue?vue&type=script&lang=js&"
export * from "./saas_list.vue?vue&type=script&lang=js&"
import style0 from "./saas_list.vue?vue&type=style&index=0&id=99df036e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99df036e",
  null
  
)

export default component.exports